module.exports = __webpack_public_path__ + "static/plantation_l-01333076a5dfea112c1873ffd38c0b5e.jpg";